/* eslint-disable camelcase */

import { PLATFORM_LIST } from '../../../constants/singleWalletTesting'

import {
  bet_settle,
  bet_settle_give,
  bet_settle_jackpot,
  betNSettle,
  betNSettle_requireAmt,
  betNSettle_give,
  betNSettle_jackpot,
  betNSettle_independentJackpot_give,
} from './general'

import AELIVECOMM from './AELIVECOMM'
import AELOTTO from './AELOTTO'
import BG from './BG'
import COOLGAME from './COOLGAME'
import CG from './CG'
import CQ9 from './CQ9'
import DCS from './DCS'
import E1SPORT from './E1SPORT'
import FCEGAME from './FCEGAME'
import GOGOLI from './GOGOLI'
import HORSEBOOK from './HORSEBOOK'
import HOTROAD from './HOTROAD'
import INSPORTS from './INSPORTS'
import JDBEGAME from './JDBEGAME'
import JILITABLE from './JILITABLE'
import JOKER from './JOKER'
import KINGMAKERSLOT from './KINGMAKERSLOT'
import KINGMAKERTABLE from './KINGMAKERTABLE'
import KINGMAKERMINI from './KINGMAKERMINI'
import LUCKYPOKER from './LUCKYPOKER'
import MG from './MG'
import PPTABLE from './PPTABLE'
import PGSLOTMIXED from './PGSLOTMIXED'
import PINNACLE from './PINNACLE'
import PINOYPERYAHAN from './PINOYPERYAHAN'
import PLAYTECH from './PLAYTECH'
import PLAYTECHSLOT from './PLAYTECHSLOT'
import PPLIVE from './PPLIVE'
import PPSLOT from './PPSLOT'
import RICH88 from './RICH88'
import RTSLOT from './RTSLOT'
import RTTABLE from './RTTABLE'
import SABA from './SABA'
import SEXYBCRT from './SEXYBCRT'
import SEXYBCRT_ONEDAY from './SEXYBCRT_ONEDAY'
import SEXYBCRT_SUMMARY from './SEXYBCRT_SUMMARY'
import SKYCASINO from './SKYCASINO'
import SPADESLOT from './SPADESLOT'
import SV388 from './SV388'
import VIACASINO from './VIACASINO'
import VRLOTTO from './VRLOTTO'
import YLFISH from './YLFISH'

const platformTestScenarioList = {
  ACEWINFISH: betNSettle,
  ACEWINSLOT: betNSettle,
  AELIVECOMM,
  AELOTTO,
  AVIATOR: bet_settle,
  AWSEGAME: betNSettle,
  AWSSLOT: betNSettle,
  AWSTABLE: betNSettle,
  BG,
  BTG: bet_settle,
  CGEGAME: CG,
  CGSLOT: CG,
  COMBO: betNSettle,
  COOLGAME,
  CRASH88: bet_settle,
  CREEDROOMZ: bet_settle,
  CQ9EGAME: CQ9,
  CQ9FISH: CQ9,
  CQ9SLOT: CQ9,
  CQ9TABLE: CQ9,
  DRAGOONSOFT: bet_settle,
  E1SPORT,
  EVOLUTION: bet_settle,
  FASTSPINSLOT: bet_settle_give,
  FASTSPINFISH: betNSettle,
  FCEGAME,
  FCFISH: betNSettle_requireAmt,
  FCSLOT: betNSettle_independentJackpot_give,
  FIVEG: bet_settle,
  GOGOLI,
  GTFFISH: betNSettle_requireAmt,
  GTFSLOT: betNSettle_jackpot,
  HABANEROEGAME: bet_settle,
  HABANEROSLOT: betNSettle,
  HACKSAWEGAME: DCS,
  HACKSAWSLOT: DCS,
  HORSEBOOK,
  HOTROAD,
  IDNSLOT: bet_settle,
  ILOVEU: betNSettle,
  INSPORTS,
  JDBEGAME,
  JDBFISH: betNSettle_requireAmt,
  JDBSLOT: betNSettle_jackpot,
  JDBTABLE: bet_settle,
  JILIFISH: betNSettle,
  JILISLOT: betNSettle_independentJackpot_give,
  JILITABLE,
  JJEGAME: bet_settle,
  JJSLOT: bet_settle,
  JOKER,
  KINGMAKERSLOT,
  KINGMAKERTABLE,
  KINGMAKERMINI,
  LADYLUCK: bet_settle,
  LETSGO: bet_settle,
  LUCKY365EGAME: bet_settle,
  LUCKY365SLOT: betNSettle,
  LUCKYPOKER,
  LUDO: bet_settle,
  MAC88: bet_settle,
  MGEGAME: MG,
  MGLIVE: MG,
  MGSLOT: MG,
  MICROSLOTEGAME: bet_settle,
  MICROSLOTSLOT: bet_settle,
  MIMIEGAME: bet_settle,
  MIMISLOT: bet_settle,
  MT: CQ9,
  NEXTSPIN: bet_settle,
  NETENTSLOT: bet_settle,
  NETENTTABLE: bet_settle,
  NLC: bet_settle,
  OCTOPLAY: DCS,
  ODIN: betNSettle,
  PENGUINKING: DCS,
  PGSLOT: betNSettle_give,
  PGSLOTMIXED,
  PGTABLE: betNSettle,
  PINNACLE,
  PINOYPERYAHAN,
  PLAY8FISH: betNSettle,
  PLAY8SLOT: betNSettle,
  PLAYNGOBINGO: DCS,
  PLAYNGOEGAME: DCS,
  PLAYNGOSLOT: DCS,
  PLAYNGOTABLE: DCS,
  PLAYSTAR: bet_settle,
  PLAYTECHLIVE: PLAYTECH,
  PLAYTECHSLOT,
  PLAYTECHTABLE: PLAYTECH,
  PLAYTECHEGAME: bet_settle,
  PPEGAME: bet_settle,
  PPLIVE,
  PPSLOT,
  PPTABLE,
  RELAXEGAME: DCS,
  RELAXSLOT: DCS,
  RELAXTABLE: DCS,
  RICH88EGAME: RICH88,
  RICH88SLOT: bet_settle,
  RICH88TABLE: RICH88,
  ROYALGAMING: bet_settle,
  PTLIVE: bet_settle,
  PTSLOT: bet_settle_jackpot,
  RTSLOT,
  RTTABLE,
  SABA,
  SEXYBCRT,
  SEXYBCRT_ONEDAY,
  SEXYBCRT_SUMMARY,
  SKYCASINO,
  SMARTSOFT: bet_settle,
  SPADEEGAME: bet_settle,
  SPADEFISH: betNSettle_requireAmt,
  SPADESLOT,
  SPRIBE: bet_settle,
  SV388,
  TADAEGAME: bet_settle,
  TADAFISH: betNSettle,
  TADASLOT: betNSettle,
  TADATABLE: bet_settle,
  THREEOAKS: betNSettle,
  VENUS: SEXYBCRT,
  VIACASINO,
  VRLOTTO,
  WINFINITY: bet_settle,
  YESBINGOBINGO: bet_settle,
  YESBINGOEGAME: bet_settle,
  YESBINGOFISH: betNSettle,
  YESBINGOSLOT: bet_settle,
  YGGDRASILSLOT: DCS,
  YGGDRASILTABLE: DCS,
  YLEGAME: bet_settle,
  YLFISH,
}

export default PLATFORM_LIST.reduce((acc, {
  id: platform, abbr, gameType, supportMultiBetsInARound,
}) => {
  acc[platform] = platformTestScenarioList[platform].reduce((acc2, scenario, idx) => {
    const scenarioNo = `${abbr}-${idx + 1}`
    if (gameType === 'LIVE' && supportMultiBetsInARound && scenario.functionName === 'bet1_bet2_bet3_cancelBet123') {
      if (!acc2[scenarioNo]) acc2[scenarioNo] = {}
      acc2[scenarioNo].name = 'Place 30 bets in 3 rounds > CancelBet'
      acc2[scenarioNo].functionName = 'bet30In3Rounds_cancelBet30'
    } else {
      acc2[scenarioNo] = scenario
    }
    return acc2
  }, {})

  return acc
}, {})
